document.addEventListener("DOMContentLoaded",()=>{


/* ========================= */
/* HOVER SLIDESHOW */
/* ========================= */

document.querySelectorAll(
".tiflie-hover-gallery"
).forEach(gallery=>{

const images=
gallery.querySelectorAll(
".tiflie-image"
);

const card=
gallery.closest(
".tiflie-card"
);

if(!card || images.length<2) return;

let current=0;
let interval=null;

images[0].classList.add(
"active"
);

card.addEventListener(
"mouseenter",
()=>{

clearInterval(
interval
);

interval=
setInterval(()=>{

images[current]
.classList.remove(
"active"
);

current=
(current+1)
%
images.length;

images[current]
.classList.add(
"active"
);

},950);

}
);

card.addEventListener(
"mouseleave",
()=>{

clearInterval(
interval
);

images.forEach(
img=>{

img.classList.remove(
"active"
);

});

current=0;

images[0]
.classList.add(
"active"
);

}
);

});


/* MOBILE FILTER */

document.querySelector(
".tiflie-mobile-filter-trigger"
)?.addEventListener(
"click",
()=>{

document.getElementById(
"tiflieOpen"
)?.click();

});

});